import { gql } from '@apollo/client'

const ADD_TICKETS_TO_CART = gql`
  mutation addTicketsToCart($input: AddTicketsToCartInput!) {
    addTicketsToCart(input: $input) {
      cart {
        id
      }
      errors {
        code
        message
      }
    }
  }
`

export default ADD_TICKETS_TO_CART
